export default "__VITE_ASSET__Dy1K$vx9__"